export default {
  path: '/popup',
  component: () => import('_views/popup/index'),
  children: [
    {
      path: '',
      name: 'PopupIndex',
      meta: {
        auth: true,
        title: '弹窗进程管理',
        roles: ['ADMIN', 'AREA'],
      },
      component: () => import('_views/popup/PopupIndex/index'),
    },
  ],
}
